import React, { useEffect, useState } from "react";
import ChangePasswordDialog from "../../components/ChangePasswordDialog";
import api from "../../services/baseUrl";

export default function AccountInformationPage({
  subscriptionData,
  passwordChangeSuccess,
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [packageList, setPackageList] = useState([]);
  useEffect(() => {
    const fetchPackageList = async () => {
      try {
        const response = await api.get("/packageList");
        const data = response.data;
        setPackageList(data);
      } catch (err) {}
    };
    fetchPackageList();
  }, [subscriptionData]);

  return (
    <div className="user-profile-container">
      <form className="profile-form">
        <div className="form-grid">
          <label>
            Username:
            <input type="text" value={subscriptionData.username} readOnly />
          </label>
          <label>
            Status:
            <input type="text" value={subscriptionData.status} readOnly />
          </label>
          <label>
            Password:
            <input type="password" value={subscriptionData.password} readOnly />
          </label>
          <button type="button" onClick={() => setIsDialogOpen(true)}>
            Change Password
          </button>{" "}
          <label>
            Subscription Start:
            <input
              type="text"
              value={new Date(
                subscriptionData.subscriptionStart
              ).toLocaleDateString("en-GB")}
              readOnly
            />
          </label>
          <label>
            Subscription End:
            <input
              type="text"
              value={new Date(
                subscriptionData.subscriptionEnd
              ).toLocaleDateString("en-GB")}
              readOnly
            />
          </label>
          <label>
            Total ID:
            <input type="text" value={subscriptionData.totalID} readOnly />
          </label>
          <label>
            Total Sessions:
            <input
              type="text"
              value={subscriptionData.totalSessions}
              readOnly
            />
          </label>
          <label>
            Subscription Plans:
            <select
              name="packageID"
              value={subscriptionData.subscriptionPlans}
              className="readonly-select"
            >
              {packageList.map((packages, index) => (
                <option key={index} value={packages.packageCode}>
                  {packages.packageName}
                </option>
              ))}
            </select>
          </label>
        </div>
      </form>

      {isDialogOpen && (
        <ChangePasswordDialog
          openDialog={isDialogOpen}
          setOpenDialog={setIsDialogOpen}
          onSuccess={passwordChangeSuccess}
        />
      )}
    </div>
  );
}
